export default __webpack_public_path__ + "static/media/NL.ad8840e2.svg";